<div class="page topic-form">
  <header>
    @if (isEdit) {
      <a class="back-link" uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: discussion.id }">
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        Back to topic
      </a>
    } @else {
      @if (fromCategory(); as category) {
        <a class="back-link" uiSref="discussioncategory" [uiParams]="{ categoryId: category.id }">
          <span class="material-icons" aria-hidden="true">arrow_back</span>
          {{ category.name }}
        </a>
      } @else {
        <a class="back-link" uiSref="discussion">
          <span class="material-icons" aria-hidden="true">arrow_back</span>
          Forums
        </a>
      }
      <!-- The legacy page's reminder, dismissable as it was there. -->
      @if (showReminder()) {
        <div class="alert alert--warning topic-form__reminder">
          <span class="material-icons" aria-hidden="true">info_outline</span>
          <p class="alert__text">When creating a new forums post, please make sure to check if your question or topic has previously been posted.</p>
          <button type="button" class="topic-form__dismiss" aria-label="Dismiss reminder" (click)="dismissReminder()">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </div>
      }
    }
    <h1 class="page-h__title" tabindex="-1">{{ isEdit ? 'Edit topic' : 'New topic' }}</h1>
  </header>

  <div class="topic-form__layout">
    <form class="card topic-form__card" (submit)="$event.preventDefault(); submit()" novalidate>
      @if ((submitted() && errors.length) || serverError()) {
        <div class="errsum" tabindex="-1" role="alert">
          @if (errors.length) {
            <b>Fix {{ errors.length === 1 ? '1 thing' : errors.length + ' things' }} to post</b>
            <ul>
              @for (e of errors; track e.field) {
                <li><button type="button" class="errsum__link" (click)="focusField(e.field)">{{ e.message }}</button></li>
              }
            </ul>
          } @else {
            <b>Couldn't save your changes.</b> {{ serverError() }}
          }
        </div>
      }

      <p class="field__hint">Fields marked * are required.</p>

      <div class="field">
        @if (isEdit) {
          <span class="field__label">Category</span>
          <p class="topic-form__readonly">{{ discussion.category?.name }}</p>
          <p class="field__hint">The category can't be changed after posting.</p>
        } @else {
          <label class="field__label" for="topicCategory">Category <span class="field__req" aria-hidden="true">*</span></label>
          <select
            id="topicCategory"
            class="field__input"
            required
            [class.is-invalid]="error('category')"
            [attr.aria-invalid]="!!error('category')"
            [attr.aria-describedby]="error('category') ? 'topicCategoryError' : null"
            (change)="categoryId.set(+$any($event.target).value || null)">
            <option value="" [selected]="!categoryId()">Choose a category</option>
            @for (cat of categories(); track cat.id) {
              <option [value]="cat.id" [selected]="cat.id === categoryId()">{{ cat.displayName }}</option>
            }
          </select>
          @if (error('category'); as message) {
            <p class="field__error" id="topicCategoryError">{{ message }}</p>
          }
        }
      </div>

      <div class="field">
        <label class="field__label" for="topicTitle">Title <span class="field__req" aria-hidden="true">*</span></label>
        <input
          id="topicTitle"
          class="field__input"
          type="text"
          required
          [value]="title()"
          [class.is-invalid]="error('title')"
          [attr.aria-invalid]="!!error('title')"
          [attr.aria-describedby]="error('title') ? 'topicTitleError' : (similar().length ? 'topicSimilar' : null)"
          (input)="setTitle($any($event.target).value)">
        @if (error('title'); as message) {
          <p class="field__error" id="topicTitleError">{{ message }}</p>
        }
        <!-- Similar topics appear while typing, so say so without moving focus. -->
        <p class="sr-only" role="status">{{ similar().length ? similar().length + (similar().length === 1 ? ' similar topic' : ' similar topics') + ' listed under the title' : '' }}</p>
        @if (similar().length) {
          <div class="similar" id="topicSimilar">
            <p class="similar__title">Similar topics: check these first</p>
            <ul class="similar__list">
              @for (topic of similar(); track topic.id) {
                <li><a uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: topic.id }" target="_blank"><span [innerHTML]="topic.title | emojiHtml"></span><span class="sr-only"> (opens in a new tab)</span></a></li>
              }
            </ul>
          </div>
        }
      </div>

      <div class="field">
        <span class="field__label" id="topicContentLabel">Topic text <span class="field__req" aria-hidden="true">*</span></span>
        <ut-editor
          [id]="fieldIds.content"
          [value]="content()"
          textAreaLabel="Topic text"
          [mentionsRelativeToParent]="true"
          [textRequired]="true"
          [ariaInvalid]="!!error('content')"
          [ariaDescribedBy]="error('content') ? 'topicContentError' : null"
          (valueChange)="content.set($event)"></ut-editor>
        @if (error('content'); as message) {
          <p class="field__error" id="topicContentError">{{ message }}</p>
        }
        <p class="field__hint">Markdown and &#64;mentions work here.</p>
      </div>

      <div class="form-actions">
        @if (isEdit) {
          <a class="ut-btn ut-btn--secondary" uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: discussion.id }">Cancel</a>
        }
        <button type="submit" class="ut-btn" [disabled]="saving()">
          @if (saving()) {
            {{ isEdit ? 'Saving…' : 'Creating…' }}
          } @else {
            {{ isEdit ? 'Save changes' : 'Create topic' }}
          }
        </button>
      </div>
    </form>
  </div>
</div>
